import PropTypes from 'prop-types';

const OptionsForm = (props) => {
  return (
    <>
      {props.datos.map((opcion) => (
        <option key={opcion.codigo} value={opcion.codigo}>
          {opcion.nombre}
        </option>
      ))}
    </>
  );
};

OptionsForm.propTypes = {
  datos: PropTypes.arrayOf(
    PropTypes.shape({ codigo: PropTypes.string, nombre: PropTypes.string }),
  ),
};

export default OptionsForm;
